document.addEventListener("turbo:load", function () {
  document.querySelectorAll('.tab-link').forEach(button => {
    button.addEventListener('click', () => {
      document.querySelectorAll('.tab-content').forEach(tab => tab.classList.add('hidden'));
      document.getElementById(button.dataset.tab).classList.remove('hidden');
      // Elimina la clase 'text-xl' de todas las pestañas
      document.querySelectorAll('.tab-link').forEach(tab => {
        tab.classList.remove('font-bold','underline');
      });
      // Agrega la clase 'text-xl' a la pestaña seleccionada
      button.classList.add('font-bold','underline');
    });
  });

  // Funcionalidad de tabs
  const tabLinks = document.querySelectorAll('.tab-link');
  const tabContents = document.querySelectorAll('.tab-content');
  
  function showTab(tabId) {
    // Ocultar todos los contenidos
    tabContents.forEach(content => {
      content.classList.add('hidden');
    });
    
    // Mostrar el contenido seleccionado
    const selectedContent = document.getElementById(tabId);
    if (selectedContent) {
      selectedContent.classList.remove('hidden');
    }
    
    // Actualizar estilos de los tabs
    tabLinks.forEach(link => {
      if (link.getAttribute('data-tab') === tabId) {
        link.classList.add('font-bold', 'underline', 'text-gray-900', 'bg-gray-100', 'rounded');
      } else {
        link.classList.remove('font-bold', 'underline', 'text-gray-900', 'bg-gray-100', 'rounded');
      }
    });
  }

  // Agregar event listeners a los tabs
  tabLinks.forEach(link => {
    link.addEventListener('click', function() {
      const tabId = this.getAttribute('data-tab');
      showTab(tabId);
    });
  });

  // Mostrar el primer tab por defecto
  showTab('tab1');
});
